import { Text } from 'src/onboarding/components/typography/Text/Text';
import styles from '../../styles/style.module.scss';
import { t } from '@web-solutions/module-localization';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import plateImg from '../../../../assets/images/plate.png';
import womenImg from '../../../../assets/images/women.png';
import womanImg from '../../../../assets/images/woman.png';
import menImg from '../../../../assets/images/eat-what-you-love-men1.webp';
import men2Img from '../../../../assets/images/eat-what-you-love-men2.webp';
import { ReactComponent as LightningSvg } from '../../../../assets/images/lightning.svg';
import { ReactComponent as CheckWhiteBgSvg } from '../../../../assets/images/checkWhiteBg.svg';
import { ReactComponent as ErrorRedSvg } from '../../../../assets/images/errorRedBg.svg';
import { useStore } from 'src/onboarding/store/store';

const EatLoseContainer = () => {
  const gender = useStore((state) => state.gender);
  const isMale = gender === 'Male';

  const dietsItems = [
    t('onboarding.personalPlan.eatLose.excludeFoods'),
    t('onboarding.personalPlan.eatLose.gainWeight'),
  ];

  const planItems = [
    t('onboarding.personalPlan.eatLose.enjoyFood'),
    t('onboarding.personalPlan.eatLose.keepWeightOff'),
  ];

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const checkDays = [1, 2];

  return (
    <div className={styles.loseWeightContainer}>
      <div className={styles.dietsContainer}>
        <div className={styles.dietsWrapper}>
          <Text size='m' medium style={{ paddingBottom: '42px' }}>
            {t('onboarding.personalPlan.eatLose.diets')}
          </Text>
          <img className={styles.plate} src={plateImg} alt='plate' />
          <img className={styles.women} src={isMale ? menImg : womenImg} alt='woman' />
          <div className={styles.blurWhite}></div>
        </div>
        <div className={styles.dietItems}>
          {dietsItems.map((item) => (
            <div className={styles.dietItem} key={item}>
              <div style={{ width: 16 }}>
                <ErrorRedSvg />
              </div>
              <Caption size='xs'>{item}</Caption>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.foodzeePlanContainer}>
        <div className={styles.foodzeePlanWrapper}>
          <div className={styles.planTitle}>
            <Text size='m' medium>
              {t('onboarding.personalPlan.eatLose.foodzeePlan')}{' '}
            </Text>
            <LightningSvg />
          </div>
          <div className={styles.calendar}>
            {days.map((day) => (
              <div key={day} className={styles.calendarDay}>
                {checkDays.includes(day) ? (
                  <span>
                    <CheckWhiteBgSvg />
                  </span>
                ) : (
                  day
                )}
              </div>
            ))}
          </div>
          <img className={styles.woman} src={isMale ? men2Img : womanImg} alt='woman' />
          <div className={styles.blurGreen}></div>
        </div>
        <div className={styles.dietItems}>
          {planItems.map((item) => (
            <div className={styles.dietItem} key={item}>
              <div style={{ width: 16 }}>
                <CheckWhiteBgSvg />
              </div>
              <Caption size='xs'>{item}</Caption>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EatLoseContainer;
